import React, { useRef, useEffect } from 'react';
import { Box, Button, makeStyles, IconButton } from '@material-ui/core';
import { Alert as Alertm } from '@material-ui/lab';
import CloseIcon from '@material-ui/icons/Close';
import clsx from 'clsx';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';

const useStyles = makeStyles(theme => ({
  root: {},
  wrapper: {
    display: 'block',
    position: 'fixed',
    zIndex: 11,
    boxSizing: 'border-box',

    padding: '0 16px'
  },
  alert: {
    position: 'relative',
    top: 0,
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    margin: 0,
    paddingTop: '12px'
  },
  fullWidth: { minWidth: 470 },
  button: {
    marginLeft: theme.spacing(1),
    minWidth: 48,
    padding: 0
  },
  no: {
    minWidth: 48,
    padding: 0,
    borderColor: theme.palette.error.main,
    color: theme.palette.error.main,
    borderColor: theme.palette.error.main,
    '&:hover': {
      borderColor: theme.palette.error.dark
    }
  },
  okSuccess: {
    minWidth: 48,
    padding: 0,
    borderColor: theme.palette.success.main,
    color: theme.palette.success.main,
    borderColor: theme.palette.success.main,
    '&:hover': {
      borderColor: theme.palette.success.dark
    }
  },
  okError: {
    minWidth: 48,
    padding: 0,
    borderColor: theme.palette.error.main,
    color: theme.palette.error.main,
    borderColor: theme.palette.error.main,
    '&:hover': {
      borderColor: theme.palette.error.dark
    }
  }
}));

function Alert({
  variant,
  handleClose,
  asConfirm,
  handleYes,
  message,
  fullWidth,
  asOk,
  handleOk,
  link,
  handleLink,
  messageAfter
}) {
  const classes = useStyles();
  const messagesEndRef = useRef(null);
  const { pageWidth } = useSelector(state => state.common);

  const scrollToTop = () => {
    // we need to stop smoth behavour because, In update transactions alao uses scroll view at perticular possition ,
    // smooth behaviour take own asyc time so this will mismatch lead to scroll at top message ragrdless perticular position in child component will scroll.

    // messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
    messagesEndRef.current.scrollIntoView();
  };

  useEffect(() => {
    message !== 'Invalid or Expired token' && scrollToTop();
  }, [message]);

  if (message === 'Invalid or Expired token') {
    return null;
  }

  return (
    <Box style={{ width: '100%' }} className={classes.wrapper}>
      <Box mb={1} className={clsx(classes.alert)} ref={messagesEndRef}>
        <Alertm
          className={clsx(fullWidth && classes.fullWidth)}
          severity={variant}
          action={
            asConfirm ? (
              <Box>
                <Button
                  size="small"
                  className={classes.no}
                  onClick={() => handleClose()}
                  variant="outlined"
                >
                  no
                </Button>
                <Button
                  className={classes.button}
                  size="small"
                  onClick={() => handleYes()}
                  variant="outlined"
                  color="secondary"
                >
                  yes
                </Button>
              </Box>
            ) : asOk ? (
              <Button
                className={
                  variant === 'success' ? classes.okSuccess : classes.okError
                }
                size="small"
                onClick={() => handleOk()}
                variant="outlined"
                color={variant}
              >
                OK
              </Button>
            ) : (
              <IconButton
                aria-label="close"
                color="inherit"
                size="small"
                onClick={() => handleClose()}
              >
                <CloseIcon fontSize="inherit" />
              </IconButton>
            )
          }
        >
          <span>
            {message || 'Something went wrong.'}
            {link && (
              <Link color="secondary" to="" onClick={() => handleLink()}>
                {link}
              </Link>
            )}
            {messageAfter && messageAfter}
          </span>
        </Alertm>
      </Box>
    </Box>
  );
}

export default Alert;
